module.exports = __webpack_public_path__ + "media/assets/community/badge-subject-leader-26e7bd9517c618fa6d5b4dfea59931bd202a9c557c7ccdd2c626954694bde40b.png";